/**
 * Android app launch shell — see public/app-launch-sw.js for how it removes the white gap
 * before the site's first paint on app launch. Only the splash is cached; pages never are.
 *
 * Doctor devices are excluded: their /apphome is already served by doctor-shell-sw.js
 * (scope /), and this worker's narrower /apphome/ scope would take precedence over it.
 */
const SW_PATH = '/app-launch-sw.js';
const SW_SCOPE = '/apphome/';

/** Written by public/app-launch-shell.html (keep in sync with scripts/gen-app-launch-shell.js). */
const APP_LAUNCH_REFERRER_KEY = 'p24-app-launch-referrer';
const REFERRER_MAX_AGE_MS = 10000;

/**
 * The shell hop makes the real page's document.referrer the launch URL itself instead of the
 * TWA's `android-app://…`. Put the original back before any other script (analytics, isPWA)
 * reads it, so launches report exactly as before. No-op unless we just came from the shell.
 */
export const APP_LAUNCH_REFERRER_INLINE_SCRIPT = `(function(){try{var k='${APP_LAUNCH_REFERRER_KEY}';var v=sessionStorage.getItem(k);if(!v)return;sessionStorage.removeItem(k);v=JSON.parse(v);if(Date.now()-v.t>${REFERRER_MAX_AGE_MS}||document.referrer!==location.href)return;Object.defineProperty(document,'referrer',{configurable:true,get:function(){return v.r}});}catch(e){}})();`;

const isServiceWorkerSupported = () => typeof window !== 'undefined' && 'serviceWorker' in navigator;

export const unregisterAppLaunchShell = async () => {
  if (!isServiceWorkerSupported()) return;
  const registration = await navigator.serviceWorker.getRegistration(SW_SCOPE);
  if (registration?.active?.scriptURL.includes(SW_PATH)) await registration.unregister();
};

/** Call on the app's launch page, after it has loaded; takes effect from the next launch. */
export const ensureAppLaunchShell = ({ isDoctorDevice }: { isDoctorDevice: boolean }) => {
  if (!isServiceWorkerSupported()) return;
  if (isDoctorDevice) {
    void unregisterAppLaunchShell().catch(() => undefined);
    return;
  }
  void navigator.serviceWorker.register(SW_PATH, { scope: SW_SCOPE }).catch(() => undefined);
};
